import { getAllUrlParams } from "../utilities";

// part of query string -> whitelist of href to keep query string;

const queryStringConfig = {
  utm: [location.host, 'https://my.epayments.com/#/registration']
}

export class QueryStringKeeper {

  static keepQueryString() {
    const queryParams = getAllUrlParams(location.search);
    const pageLinks = document.querySelectorAll('a');
    const configKeys = Object.keys(queryStringConfig);

    // Loop over all links
    Array.from(pageLinks).forEach((link) => {

      const linkHref = link.getAttribute('href');
      
      // Trying to find all tags that has to be setted for this link
      const tagsToSet = configKeys.filter((key) => queryStringConfig[key].find((url) => linkHref.indexOf(url) !== -1));

      if (tagsToSet.length) {
        const linkHrefParams = getAllUrlParams(linkHref);
        const urlParams = QueryStringKeeper.getUrlParams(queryParams, tagsToSet);

        const paramsToSet = Object.assign({}, linkHrefParams, urlParams);
        const paramsToSetKeys = Object.keys(paramsToSet);
        
        if (!paramsToSetKeys.length || !window.URL) { return; }

        const url = new URL(linkHref);
        const paramsAsString = QueryStringKeeper.getParamsAsString(url.hash ? urlParams : paramsToSet);
        let newHref = `${url.origin}${url.pathname}${paramsAsString}`;
       
        if (url.hash) {
          newHref += `/${url.hash}`;
        }

        link.setAttribute('href', newHref);
      }
    });
 }

 static getParamsAsString(params) {
  const paramsToSetKeys = Object.keys(params);
  if (!paramsToSetKeys.length) { return ''; }
  
  return paramsToSetKeys.reduce((acc, current, index, arr) => {
    const isLast = index === arr.length - 1;
    acc +=`${current}=${params[current]}${isLast ? '' : '&'}`;
    return acc;
  }, '?');
 }

 static getUrlParams(urlParams, paramsToSet) {
  return Object.keys(urlParams).reduce((acc, current) => {
    const isSettable = paramsToSet.find((param) => current.indexOf(param) !== -1);
    if (isSettable) {
      acc[current] = urlParams[current];
    }
    return acc;
  }, {});
 }

}
